import { LOCALES, type LocaleCode } from './locale'

export const DEFAULT_OG_IMAGE = 'https://s3-eu-west-1.amazonaws.com/static.byhours.com/img/usuarios/hotel_meta.jpg'

/** Mismos códigos que `LOCALES`, en el orden público. */
export const PUBLIC_LOCALES: readonly LocaleCode[] = LOCALES.map((locale) => locale.code)

export const OG_LOCALE_BY_CODE: Record<LocaleCode, string> = Object.fromEntries(
  LOCALES.map((locale) => [locale.code, `${locale.language}_${locale.country}`])
) as Record<LocaleCode, string>

export function stripHtml(value: string | undefined): string {
  if (!value) return ''
  return value.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim()
}

/** JSON-LD seguro para incrustar en `<script>`: evita que `</script>` corte el HTML. */
export function toJsonLd(data: unknown): string {
  return JSON.stringify(data).replace(/</g, '\\u003c')
}

export function toAbsoluteUrl(value: string | undefined, baseUrl: string): string | undefined {
  if (!value) return undefined
  if (value.startsWith('https://') || value.startsWith('http://')) return value
  const base = baseUrl.replace(/\/$/, '')
  if (!base) return undefined
  return `${base}${value.startsWith('/') ? value : `/${value}`}`
}
